<template>
  <v-sheet outlined class="pa-4">
    <h3 class="mb-4" data-testid="regimen_grid_customization_panel_status">
      {{ status_text }}
    </h3>
    <v-btn
      color="primary"
      block
      class="mb-2"
      data-testid="regimen_grid_customization_panel_customize_grid"
      @click="$emit('customize')"
    >
      {{ $t("regimen_container_edit.customize_grid") }}
    </v-btn>
    <v-btn
      block
      :disabled="!canUpdateFromSource"
      data-testid="regimen_grid_customization_panel_update_from_source"
      @click="update_from_source_dialog = true"
    >
      {{ $t("regimen_container_edit.update_from_source") }}
    </v-btn>

    <v-dialog v-model="update_from_source_dialog" max-width="600">
      <v-card>
        <v-card-title>
          {{ $t("regimen_container_edit.update_from_source") }}
        </v-card-title>
        <v-card-text data-testid="regimen_grid_customization_panel_update_from_source_warning">
          {{ update_from_source_warning }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            data-testid="regimen_grid_customization_panel_update_from_source_cancel"
            @click="update_from_source_dialog = false"
          >
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            data-testid="regimen_grid_customization_panel_update_from_source_confirm"
            @click="update_from_source"
          >
            {{ $t("common.continue") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
export default {
  data() {
    return {
      update_from_source_dialog: false,
    };
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    canUpdateFromSource: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    status_text() {
      return this.$t(`regimen_container_edit.status_${this.status}`);
    },
    update_from_source_warning() {
      return this.status === "customized"
        ? this.$t("regimen_container_edit.update_from_source_customized_warning")
        : this.$t("regimen_container_edit.update_from_source_warning");
    },
  },
  methods: {
    update_from_source() {
      this.update_from_source_dialog = false;
      this.$emit("update-from-source");
    },
  },
};
</script>
